import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-group-dialog',
    templateUrl: './edit-group-or-team-dialog.component.html',
    styleUrls: ['./edit-group-or-team-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditGroupOrTeamDialogComponent implements OnInit {

    muTransRatePercent = 0;
    salesCommissPercent = 0;

    constructor(
    public dialogRef: MatDialogRef<EditGroupOrTeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        console.log(this.data);

        if (this.data.defaultUserMarkup) {
            if (this.data.defaultUserMarkup.ratePerTrans) {
                this.muTransRatePercent = Number((this.data.defaultUserMarkup.ratePerTrans * 100).toFixed(3));
            }
        } else {
            this.data.defaultUserMarkup = {
                useInheritedValues: true,
                ratePerTrans: 0,
                costPerTrans: 0,
                fixedMonthlyFeeTotal: 0
            };
        }

        if (this.data.defaultUserCommission) {
            if (this.data.defaultUserCommission.salesCommissionPercent) {
                this.salesCommissPercent =
                Number((this.data.defaultUserCommission.salesCommissionPercent * 100).toFixed(3));
            }
        } else {
            this.data.defaultUserCommission = {
                useInheritedValues: true,
                salesCommissionPercent: 0
            };
        }
    }

    ngOnInit(): void {
    }

    inheritFromDisplay() {
        if (this.data.type === 'group') {
            return 'Organization';
        } else if (this.data.type === 'team') {
            return 'Group';
        } else {
            return 'Team';
        }
    }
    save() {
        this.data.defaultUserMarkup.ratePerTrans =
        this.muTransRatePercent ? Number((this.muTransRatePercent / 100).toFixed(6)) : 0;
        this.data.defaultUserCommission.salesCommissionPercent =
        this.salesCommissPercent ? Number((this.salesCommissPercent / 100).toFixed(6)) : 0;

        this.dialogRef.close({
            ...this.data,
        });
    }

}
